var $27fab53a576de9dd$exports = {};
$27fab53a576de9dd$exports = {
    "dismiss": `Opusti`
};


export {$27fab53a576de9dd$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
